import { ByUserForm } from './ByUserForm'
import { withByUserForm } from './withByUserForm'

const ConnectedByUserForm = withByUserForm(ByUserForm)

export { ConnectedByUserForm as ByUserForm }
